import { useCallback, useRef, useState } from "react";

/** Keep content mounted during dismissal; navigate only after the sheet closes. */
export function useSettingsDetail<T>(initial: T) {
  const [detail, setDetail] = useState<T>(initial);
  const [visible, setVisible] = useState(false);
  const afterCloseAction = useRef<(() => void) | null>(null);
  const open = useCallback((next: T) => {
    afterCloseAction.current = null;
    setDetail(next);
    setVisible(true);
  }, []);
  const close = useCallback(() => setVisible(false), []);
  const leave = useCallback((action: () => void) => {
    afterCloseAction.current = action;
    setVisible(false);
  }, []);
  const afterClose = useCallback(() => {
    const action = afterCloseAction.current;
    afterCloseAction.current = null;
    action?.();
  }, []);
  return { detail, visible, open, close, leave, afterClose };
}
